import { useState, forwardRef, useRef, useEffect, useImperativeHandle } from "react";
import { Button, FormHelperText, InputAdornment, TextField, } from "@mui/material";
import { TextBoxFormprop, TextBoxNoFormprop, TextBoxNumberNoFormprop, TextBoxNumberFormprop, TextBoxInTableNoFormprop } from "./TextBoxProps";
import { SxProps } from "@mui/material";
import { Controller, useWatch, useFormContext } from "react-hook-form";
import { MdDeleteForever } from "react-icons/md"
import { undefinedOrNull } from "utilities/Function";

export const TextBoxForm = forwardRef((props: TextBoxFormprop, ref) => {
    const {
        name,
        startAdornment,
        endAdornment,
        fullWidth = true,
        isshowTextCont = true,
    } = props;

    const {
        control,
        register,
        setValue,
        getValues,
        watch
    } = useFormContext();

    const FieldName = useWatch({
        control,
        name: name,
    });

    const [Focus, SetFocus] = useState(false);
    const maxLengthText: SxProps = {
        // "& input":{
        "::after": {
            content:
                isshowTextCont && props.maxLength
                    ? `"${getValues(name) ? getValues(name).length : 0}/${props.maxLength}"`
                    : '""',
            position: "absolute",
            bottom: "5px",
            right: "10px",
            color: "#989898",
            fontSize: "10px",
        },
        // }
    };
    useEffect(() => {
        if (undefinedOrNull(props.value)) {
            setValue(name, props.value);
        }
    }, [])
    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, onBlur, value, ref },
                fieldState: { invalid, error }, }) => (
                <>
                    <TextField
                        {...props}
                        key={name}
                        inputRef={ref}
                        {...register(name)}
                        name={name}
                        id={name}
                        value={value}
                        label={props.label}
                        required={props.required || false}
                        error={error?.message != null}
                        type={props.type || "text"}
                        disabled={props.disabled}
                        variant={props.variant || "outlined"}
                        fullWidth={fullWidth}
                        margin={props.margin}
                        style={props.style}
                        size={"small"}
                        autoComplete={"off"}
                        sx={[{ ...maxLengthText }, {
                            "label.MuiInputLabel-shrink": {
                                // backgroundColor: props.disabled ? "#E9E8E8" : "#FFF",
                                // backgroundColor: "rgba(255,255,255,0.95)",
                                top: "0px",
                            },
                            ".MuiInputLabel-outlined": {
                                top: "0px",
                            },
                            ".MuiInputLabel-asterisk": {
                                color: "red"
                            }
                        }]}
                        inputProps={{
                            maxLength: props.maxLength ? props.maxLength : null,
                            name,
                            className: props.className,
                        }}
                        // InputLabelProps={{
                        //     shrink: FieldName || Focus ? true : false,
                        // }}
                        // InputProps={props.startAdornment ? { startAdornment } : { endAdornment }}
                        InputProps={{
                            startAdornment: props.startAdornment ? (
                                <InputAdornment position="start">
                                    {props.startAdornment}
                                </InputAdornment>
                            ) : null,
                            endAdornment: props.endAdornment ? (
                                <InputAdornment position="end">
                                    {props.endAdornment}
                                </InputAdornment>
                            ) : null,
                        }}
                        InputLabelProps={{
                            shrink: (props.startAdornment || props.endAdornment) ? true : ((FieldName || Focus) ? true : false),
                        }}
                        onChange={(e) => {
                            onChange(e);
                            let sValueSet = e.target.value;
                            if(props.isToUpperCase && e.target.value){
                                sValueSet = e.target.value.toUpperCase();
                            }
                            if (props.type == "email" || props.mode == "email") {
                                sValueSet = sValueSet?.replace(/[^A-Za-z0-9@._]/gi, "");
                            } else if (props.lang == "en") {
                                if (props.mode == "name") {
                                    sValueSet = sValueSet?.replace(/[^A-Za-z ]/gi, "");
                                } else {
                                    //sValueSet = sValueSet?.replace(/[^A-Za-z0-9 ]/gi, "");
                                    sValueSet = sValueSet?.replace(/[^A-Za-z0-9-_.,'"!?;:&@ ]/gi, "");
                                }

                            } else if (props.lang == "th") {
                                if (props.mode == "name") {
                                    sValueSet = sValueSet?.replace(/[^\u0E00-\u0E7F ]/gi, "");
                                } else {
                                    sValueSet = sValueSet?.replace(/[^\u0E00-\u0E7F0-9 ]/gi, "");
                                }

                            }else if (props.lang == "number") {
                                sValueSet = sValueSet?.replace(/[^0-9]/gi, "");
                            }
                            
                            setValue(name, sValueSet, { shouldValidate: true });
                            props.onChange && props.onChange(sValueSet);
                        }}
                        onBlur={(event) => {
                            SetFocus(false);
                            onBlur();

                            setValue(name, event.target.value, { shouldValidate: true });
                            props.onBlur && props.onBlur(event);
                        }}
                        onKeyPress={(event) => {
                            props.onKeyPress && props.onKeyPress(event);
                        }}
                        onKeyDown={(event) => {
                            props.onKeyDown && props.onKeyDown(event);
                        }}
                        onKeyUp={(event) => {
                            props.onKeyPress && props.onKeyPress(event);
                        }}
                        onFocus={() => {
                            SetFocus(true);
                        }}
                    />
                    {error ? (
                        <FormHelperText sx={{ color: "red" }}>
                            {error.message}
                        </FormHelperText>
                    ) : null}
                </>
            )
            }
        />
    );
});

export default TextBoxForm;

export const TextBoxNoForm = forwardRef((props: TextBoxNoFormprop, ref) => {
    const {
        startAdornment,
        endAdornment,
        multiline = false,
        fullWidth = true,
        isshowTextCont = true,
    } = props;
    const [value, setValue] = useState<string>(props.value);
    const [IsRequire, SetIsRequire] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(false);
    const maxLengthText: SxProps = {
        // "& input":{
        "::after": {
            content:
                isshowTextCont && props.maxLength
                    ? `"${value ? value.length : 0}/${props.maxLength}"`
                    : '""',
            position: "absolute",
            bottom: "5px",
            right: "10px",
            color: "#989898",
            fontSize: "10px",
        },
        // }
    };

    useImperativeHandle(ref, () => ({
        onDisabled(val: boolean) {
            setDisabled(val);
        },
        onRequire(val: boolean) {
            SetIsRequire(val);
        },
    }));
    useEffect(() => {
        if (props.onRef) {
            props.onRef(ref);
        }
    }, [ref])
    useEffect(() => { setDisabled(props.disabled || false) }, [props.disabled]);
    return (
        <TextField
            {...props}
            key={props.id}
            inputRef={ref}
            name={props.id}
            value={value}
            label={props.label}
            type={props.type || "text"}
            disabled={disabled}
            variant={props.variant || "outlined"}
            fullWidth={fullWidth}
            margin={props.margin || "normal"}
            style={props.style}
            size={"small"}
            autoComplete={"off"}
            multiline={multiline}
            rows={props.rows}
            inputProps={{
                maxLength: props.maxLength ? props.maxLength : null,
                name: props.id,
                style: props.inputPropsStyle,
                placeholder: props.placeholder
            }}
            InputProps={props.startAdornment ? { startAdornment } : { endAdornment }}
            onChange={(e) => {
                setValue(e.target.value);
                if (e.target.value) {
                    SetIsRequire(false)
                }
                props.onChange && props.onChange(e.target.value);
            }}
            onBlur={(event) => {
                props.onBlur && props.onBlur(event);
            }}
            onKeyPress={(event) => {
                props.onKeyPress && props.onKeyPress(event);
            }}
            onKeyDown={(event) => {
                props.onKeyDown && props.onKeyDown(event);
            }}
            onKeyUp={(event) => {
                props.onKeyPress && props.onKeyPress(event);
            }}
            sx={[{ ...maxLengthText }, {
                "label.MuiInputLabel-shrink": {
                    // backgroundColor: "rgb(255 255 255 / 18%)",
                    // backgroundColor: "rgba(255,255,255,0.95)",
                    top: "0px",
                },
                ".MuiInputLabel-outlined": {
                    top: "0px",

                },
                ".MuiInputLabel-asterisk": {
                    color: "red"
                },
                "& .MuiOutlinedInput-root": {
                    "& > fieldset": IsRequire ? { borderColor: "red" } : {},
                },
            }]}
        />
    );
});

export const TextBoxInTableNoForm = forwardRef((props: TextBoxInTableNoFormprop, ref) => {
    const {
        isButtonDelete = true,
    } = props;

    useEffect(() => {
        if (props.onRef) {
            props.onRef(ref);
        }
    }, [ref])

    return (
        <div style={{ display: "flex" }} key={"divIn-" + props.id}>
            {isButtonDelete &&
                <Button id={"but-" + props.id} variant="contained" color="error" style={{
                    height: "33px",
                    marginBottom: "8px",
                    marginTop: "8px",
                    marginRight: "5px",
                    borderRadius: "10px",
                    minWidth: "36px",
                    boxShadow: "rgba(0, 0, 0, 0.189) 0px 5px 15px",
                    padding: "0px"
                }}
                    onClick={(e) => props.onDelete && props.onDelete(e)}>
                    <MdDeleteForever style={{ fontSize: "24px" }} />
                </Button>
            }
            <TextBoxNoForm
                {...props}
                ref={ref}
                placeholder={props.placeholder ? props.placeholder : "Enter name"}
                inputPropsStyle={{ height: "15px", fontSize: "14px" }}
                style={{ marginTop: "8px" }}
            />
        </div>
    );
});


export const InputNumberNoForm = forwardRef((props: TextBoxNumberNoFormprop, ref) => {
    const {
        maxInteger = 12,
        maxDigits = 8,
        startAdornment,
        endAdornment,
    } = props;

    const inputEl = useRef(null)
    let inputEl2 = null;
    const [IsRequire, SetIsRequire] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(false);
    const onChange = (e) => {
        let sValue = e.target.value;
        let nVal = (sValue + "").replaceAll(/,/g, '');
        nVal = nVal.replaceAll(",", "")
        if (isNumber(nVal)) {

            if (maxInteger != undefined && maxInteger != null && maxInteger > 0) {
                let arrDig = nVal.split(".");
                let valInteger = arrDig[0].substring(0, maxInteger)
                if (arrDig.length > 1) {
                    nVal = valInteger + "." + arrDig[1];
                } else {
                    nVal = valInteger;
                }
            }
            if (maxDigits == 0) {
                let arrDig = nVal.split(".");
                nVal = arrDig[0];
            }


            let nCheck = parseFloat(nVal);
            if (nCheck >= 1 || nCheck == 0) {
                e.target.value = nVal;
            }
            else if (nCheck > 0 && nCheck < 1) {
                e.target.value = nVal;
            }
            else {
                e.target.value = '';
            }
        } else {
            if (nVal == "NA" || nVal == "Na" || nVal == "nA" || nVal == "N/a" || nVal == "N/A" || nVal == "na" || nVal == "n/a") {
                e.target.value = "N/A";
            } else if (nVal == "n" || nVal == "N") {
                e.target.value = "N"
            } else if (nVal == "a" || nVal == "A") {
                e.target.value = 'A'
            } else if (nVal == "N/") {
                e.target.value = "N/"
            } else {
                e.target.value = '';
            }
        }
        if (e.target.value) {
            SetIsRequire(false);
        }
        inputEl2 = e;
        props.onChange && props.onChange(e.target.value, inputEl2)
    }

    const onBlur = (e) => {
        let sValue = e.target.value;
        let nVal = (sValue + "").replaceAll(/,/g, '');
        if (isNumber(nVal)) {
            let nCheck = parseFloat(nVal);
            if (nCheck >= 1 || nCheck == 0) {
                e.target.value = commaSeparateNumber(nVal, props.maxDigits, props.maxInteger);
            }
            else if (nCheck > 0 && nCheck < 1) {
                e.target.value = commaSeparateNumber(nVal, props.maxDigits, maxInteger);
            }
            else {
                e.target.value = '';
            }
        } else {
            if (nVal == "NA" || nVal == "Na" || nVal == "nA" || nVal == "N/a" || nVal == "N/A" || nVal == "na" || nVal == "n/a") {
                e.target.value = "N/A";
            } else if (nVal == "n" || nVal == "N") {
                e.target.value = ''
            } else if (nVal == "a" || nVal == "A") {
                e.target.value = ''
            } else if (nVal == "N/") {
                e.target.value = ''
            } else {
                e.target.value = '';
            }
        }
        inputEl2 = e;
        props.onBlur && props.onBlur(e.target.value, inputEl2)
    }

    useEffect(() => {
        if (props.onRef) {
            props.onRef(ref);
        }
    }, [ref])

    useImperativeHandle(ref, () => ({
        onDisabled(val: boolean) {
            setDisabled(val);
        },
        onRequire(val: boolean) {
            SetIsRequire(val);
        },
    }));
    useEffect(() => { setDisabled(props.disabled || false) }, [props.disabled]);
    return (
        <TextField type={"text"}
            style={{ width: "100%", ...props?.style }}
            {...props}
            value={undefined}
            //ref={inputEl}
            key={props.id}
            variant={props.variant || "outlined"}
            size="small"
            label={props.label}
            inputProps={{
                style: { textAlign: props.textAlign || "right", height: props.mode == "Table" ? "15px" : "", fontSize: props.mode == "Table" ? "14px" : "" },
            }}
            InputProps={props.startAdornment ? { startAdornment } : { endAdornment }}
            defaultValue={
                props.isExponential ?
                    ConvertToExponential(props.value, props.ShowDigits)
                    :
                    commaSeparateNumber(props.value, maxDigits, props.ShowDigits)
            }
            onChange={onChange}
            onBlur={onBlur}
            placeholder={props.placeholder}
            disabled={disabled || false}
            onKeyPress={(event) => {
                props.onKeyPress && props.onKeyPress(event);
            }}
            onKeyDown={(event) => {
                props.onKeyDown && props.onKeyDown(event);
            }}
            onKeyUp={(event) => {
                props.onKeyPress && props.onKeyPress(event);
            }}
            sx={{
                "& .MuiOutlinedInput-root": {
                    "& > fieldset": IsRequire ? { borderColor: "red" } : {},
                },
            }}
        />
    );

});

export const InputNumberForm = forwardRef((props: TextBoxNumberFormprop) => {
    const {
        maxInteger = 12,
        maxDigits = 8,
        startAdornment,
        endAdornment,
        maxLength,
        ...rest
    } = props;
    const {
        control,
        register,
        getValues
    } = useFormContext();

    const FieldName = useWatch({
        control,
        name: props.name,
    });
    const [Focus, SetFocus] = useState(false);
    let inputEl2 = null;

    const _onChange = (e, onChangeFrom) => {
        // let sValue = e.target.value;
        // let nVal = (sValue + "").replaceAll(/,/g, '');
        // nVal = nVal.replaceAll(",", "")
        // if (isNumber(nVal)) {

        //     if (maxInteger != undefined && maxInteger != null && maxInteger > 0) {
        //         let arrDig = nVal.split(".");
        //         // let valInteger = arrDig[0].substring(0, maxInteger)
        //         let valInteger = parseInt(arrDig[0]) <= maxInteger ? arrDig[0] : arrDig[0].slice(0, -1);
        //         if (arrDig.length > 1) {
        //             let valueDecimal = arrDig[1] !== "" ? arrDig[1].substring(0, maxDigits) : "";
        //             nVal = valInteger + "." + valueDecimal;
        //         } else {
        //             nVal = valInteger;
        //         }
        //     }
        //     if (maxDigits == 0) {
        //         let arrDig = nVal.split(".");
        //         nVal = arrDig[0];
        //     }

        //     let nCheck = parseFloat(nVal);
        //     if (nCheck >= 1 || nCheck == 0) {
        //         e.target.value = nVal;
        //     }
        //     else if (nCheck > 0 && nCheck < 1) {
        //         e.target.value = nVal;
        //     }
        //     else {
        //         e.target.value = '';
        //     }
        // } else {
        //     if (nVal == "NA" || nVal == "Na" || nVal == "nA" || nVal == "N/a" || nVal == "N/A" || nVal == "na" || nVal == "n/a") {
        //         e.target.value = "N/A";
        //     } else if (nVal == "n" || nVal == "N") {
        //         e.target.value = "N"
        //     } else if (nVal == "a" || nVal == "A") {
        //         e.target.value = 'A'
        //     } else if (nVal == "N/") {
        //         e.target.value = "N/"
        //     } else {
        //         e.target.value = '';
        //     }
        // }
        let sValue = e.target.value;
        let nVal = (sValue + "").replaceAll(/,/g, '');
        nVal = nVal.replaceAll(",", "")
        if (isNumber(nVal)) {

            if (maxInteger != undefined && maxInteger != null && maxInteger > 0) {
                let arrDig = nVal.split(".");
                let valInteger = arrDig[0].substring(0, maxInteger)
                if (arrDig.length > 1) {
                    nVal = valInteger + "." + arrDig[1];
                } else {
                    nVal = valInteger;
                }
            }
            if (maxDigits == 0) {
                let arrDig = nVal.split(".");
                nVal = arrDig[0];
            }

            let nCheck = parseFloat(nVal);
            if (maxLength && maxLength > 0) {
                if (maxLength < nCheck) {
                    nVal = maxLength + "";
                }
            }

            if (nCheck >= 1 || nCheck == 0) {
                e.target.value = nVal;
            }
            else if (nCheck > 0 && nCheck < 1) {
                e.target.value = nVal;
            }
            else {
                e.target.value = '';
            }
        } else {
            if (nVal == "NA" || nVal == "Na" || nVal == "nA" || nVal == "N/a" || nVal == "N/A" || nVal == "na" || nVal == "n/a") {
                e.target.value = "N/A";
            } else if (nVal == "n" || nVal == "N") {
                e.target.value = "N"
            } else if (nVal == "a" || nVal == "A") {
                e.target.value = 'A'
            } else if (nVal == "N/") {
                e.target.value = "N/"
            } else {
                e.target.value = '';
            }
        }
        inputEl2 = e;
        onChangeFrom(e);
        props.onChange && props.onChange(e.target.value, inputEl2)
    }

    const _onBlur = (e, onChange) => {
        let sValue = e.target.value;
        let nVal = (sValue + "").replaceAll(/,/g, '');
        nVal = nVal.replaceAll(",", "")
        if (isNumber(nVal)) {
            let nCheck = parseFloat(nVal);
            if (nCheck >= 1 || nCheck == 0) {
                e.target.value = commaSeparateNumberForm(nVal, props.maxDigits, maxInteger);
            }
            else if (nCheck > 0 && nCheck < 1) {
                e.target.value = commaSeparateNumberForm(nVal, props.maxDigits, maxInteger);
            }
            else {
                e.target.value = '';
            }
        } else {
            if (nVal == "NA" || nVal == "Na" || nVal == "nA" || nVal == "N/a" || nVal == "N/A" || nVal == "na" || nVal == "n/a") {
                e.target.value = "N/A";
            } else if (nVal == "n" || nVal == "N") {
                e.target.value = ''
            } else if (nVal == "a" || nVal == "A") {
                e.target.value = ''
            } else if (nVal == "N/") {
                e.target.value = ''
            } else {
                e.target.value = '';
            }
        }
        inputEl2 = e;
        onChange(e.target.value, inputEl2);
        props.onBlur && props.onBlur(e.target.value, inputEl2)
    }
    const commaSeparateNumberForm = (value: any, _MaxDigits?, _MaxInteger?) => {

        let MaxDigits = _MaxDigits || null;
        let MaxInteger = _MaxInteger || 12;
        if (value != undefined && value != null && (value + "") != "" && value != "N/A") {
            let val = parseFloat((value + "").replaceAll(",", ""))
            let sign = 1;
            if (val < 0) {
                sign = -1;
                val = -val;
            }
            if (value.toString().includes('.') && val.toString().includes('.') == false && _MaxDigits > 0) {
                return value;
            } else {
                let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();
                num = num.substring(0, MaxInteger)

                if (val.toString().includes('.')) {

                    if (MaxDigits) {
                        // num = num + '.' + (val.toString().split('.')[1]).substring(0, MaxDigits); //ตัดเศษแบบไม่ปัด
                        //.toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 2});
                        num = (+val).toLocaleString(undefined, { maximumFractionDigits: MaxDigits }).replaceAll(",", ""); //ตัดเศษแบบปัดเศษ
                    } else {
                        num = num + '.' + (val.toString().split('.')[1]);
                    }
                }
                //ตัดเศษแบบปัดเศษ กรณีส่ง Digits และมีค่า
                if (MaxDigits && num != undefined && num != null && num != "") {
                    if (MaxDigits) {
                        num = (+num).toLocaleString(undefined, { maximumFractionDigits: MaxDigits }).replaceAll(",", "");
                    } else {
                        num = num;
                    }
                }


                if (num != undefined && num != null && num != "NaN" && num != "") {
                    let indValue = (num + "").split(".");
                    let valueResult = indValue[0];
                    if ((num + "") != "0") {
                        while (/(\d+)(\d{3})/.test(valueResult)) {
                            valueResult = valueResult.replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
                        }
                        if (indValue.length > 1) {
                            valueResult = valueResult + "." + indValue[1]
                        }
                        return sign < 0 ? '-' + valueResult : valueResult;
                    } else {
                        return sign < 0 ? '-' + "0" : "0";
                    }
                } else {
                    return "";
                }
            }

        } else {
            if (value == "N/A") {
                return value;
            } else {
                return "";
            }
        }
    }

    return (
        <Controller
            name={props.name}
            control={control}
            render={({
                field: { onChange, onBlur, value, ref },
                fieldState: { invalid, error }, }) => (
                <>
                    <div style={{ display: 'flex', position: 'relative' }}>
                        <TextField type={"text"}
                            ref={ref}
                            style={{
                                width: "100%",
                                ...rest?.style
                            }}
                            {...rest}
                            id={props.name}
                            error={error?.message != null}
                            variant={props.variant || "outlined"}
                            size="small"
                            label={props.label}
                            sx={[{
                                "label.MuiInputLabel-shrink": {
                                    // backgroundColor: "rgb(255 255 255 / 18%)",
                                    // backgroundColor: "rgba(255,255,255,0.95)",
                                    top: "0px",
                                },
                                ".MuiInputLabel-outlined": {
                                    top: "0px",
                                },
                                ".MuiInputLabel-asterisk": {
                                    color: "red"
                                }
                            }]}
                            inputProps={{
                                maxLength: maxLength ? maxLength : null,
                                style: {
                                    textAlign: props.textAlign || "right",
                                    paddingRight:
                                        (props.suffix && props.suffix !== "")
                                            ? props.suffix.length > 20 ? `${props.suffix.length * 8 + 30}px` :
                                                props.suffix.length > 15 ? `${props.suffix.length * 7 + 40}px` :
                                                    props.suffix.length > 10 ? `${props.suffix.length * 6 + 50}px` :
                                                        props.suffix.length > 5 ? `${props.suffix.length * 5 + 50}px` :
                                                            props.suffix.length > 3 ? `${props.suffix.length * 4 + 45}px` :
                                                                `${props.suffix.length * 3 + 40}px`
                                            : "",
                                },
                            }}
                            InputProps={props.startAdornment ? { startAdornment } : { endAdornment }}
                            value={
                                props.isExponential ?
                                    ConvertToExponential(value, props.ShowDigits)
                                    : commaSeparateNumberForm(value, maxDigits, props.ShowDigits)
                            }
                            onChange={(e) => {
                                // onChange(e);
                                _onChange(e, onChange)
                            }}
                            onBlur={(e) => {
                                onBlur();
                                _onBlur(e, onChange);
                            }}
                            placeholder={props.placeholder}
                            disabled={props.disabled || false}
                            onKeyPress={(event) => {
                                props.onKeyPress && props.onKeyPress(event);
                            }}
                            onKeyDown={(event) => {
                                props.onKeyDown && props.onKeyDown(event);
                            }}
                            onKeyUp={(event) => {
                                props.onKeyPress && props.onKeyPress(event);
                            }}
                        />
                        {props.suffix !== undefined ? (
                            <span
                                style={{
                                    fontSize: 16,
                                    borderColor: "rgba(255, 255, 255, 0)",
                                    backgroundColor: "rgba(255, 255, 255, 0)",
                                    paddingTop: "0.77rem",
                                    paddingLeft: "0.3rem",
                                    lineHeight: "18px",
                                    height: "100%",
                                    right: '2%',
                                    position: "absolute",
                                    color: "#929292",
                                    borderLeft: '1.2px solid #d9d9d9',
                                }}
                            >
                                {props.suffix}
                            </span>
                        ) : (
                            <div></div>
                        )}
                    </div>
                    {error ? (
                        <FormHelperText sx={{ color: "red" }}>
                            {error.message}
                        </FormHelperText>
                    ) : null}
                </>
            )} />
    );

});

//#region Fun
export const isNumber = (n) => {
    return typeof (n) != "boolean" && !isNaN(n);
}

export const convertStringToNumber = (val) => {
    if (val != undefined && val != null) {
        let values = (val + "").replaceAll(",", "")
        if (values && values != "" && values != null && isNumber(values)) {
            let valConve = parseFloat(values);
            if ((valConve + "") != "NaN") {
                return valConve;
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}

export const commaSeparateNumber = (value: any, _MaxDigits?, _MaxInteger?) => {
    let MaxDigits = _MaxDigits || null;
    let MaxInteger = _MaxInteger || 12;
    if (value != undefined && value != null && (value + "") != "" && value != "N/A") {
        let val = parseFloat((value + "").replaceAll(",", ""))
        let sign = 1;
        if (val < 0) {
            sign = -1;
            val = -val;
        }
        if (value.toString().includes('.') && val.toString().includes('.') == false && _MaxDigits > 0) {
            let nuber2 = (+value).toLocaleString(undefined, { maximumFractionDigits: MaxDigits }).replaceAll(",", "");
            let nRes = "";
            if (!nuber2.toString().includes('.')) {
                let zero = ".";
                for (let i = 0; i <= _MaxDigits; i++) {
                    zero += "0";
                }
                nRes = nuber2 + zero;
            } else {
                nRes = nuber2;
            }
            return nRes;
        } else {
            let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();
            num = num.substring(0, MaxInteger)

            if (val.toString().includes('.')) {

                if (MaxDigits) {
                    // num = num + '.' + (val.toString().split('.')[1]).substring(0, MaxDigits); //ตัดเศษแบบไม่ปัด
                    //.toLocaleString(undefined, { maximumFractionDigits: 3, minimumFractionDigits: 2});
                    num = (+val).toLocaleString(undefined, { maximumFractionDigits: MaxDigits }).replaceAll(",", ""); //ตัดเศษแบบปัดเศษ
                } else {
                    num = num + '.' + (val.toString().split('.')[1]);
                }
            }
            //ตัดเศษแบบปัดเศษ กรณีส่ง Digits และมีค่า
            if (MaxDigits && num != undefined && num != null && num != "") {
                num = (+num).toLocaleString(undefined, { maximumFractionDigits: MaxDigits }).replaceAll(",", "");
                if (MaxDigits > 0) {
                    if (!num.toString().includes('.')) {
                        num = num + "." + ("0").padEnd(MaxDigits, "0");
                    } else {
                        let ar = num.split(".");
                        num = (ar[0]) + "." + (ar[1].padEnd(MaxDigits, "0"));
                    }
                } else {
                    num = num;
                }
            }


            if (num != undefined && num != null && num != "NaN" && num != "") {
                let indValue = (num + "").split(".");
                let valueResult = indValue[0];
                if ((num + "") != "0") {
                    while (/(\d+)(\d{3})/.test(valueResult)) {
                        valueResult = valueResult.replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
                    }
                    if (indValue.length > 1) {
                        valueResult = valueResult + "." + indValue[1]
                    }
                    return sign < 0 ? '-' + valueResult : valueResult;
                } else {
                    return sign < 0 ? '-' + "0" : "0";
                }
            } else {
                return "";
            }
        }

    } else {
        if (value == "N/A") {
            return value;
        } else {
            return "";
        }
    }
}

export const ConvertToExponential = (value, digit = 3, MinIntegerCount = 1) => {
    if (value != "N/A") {
        let value_ = (value + "").replaceAll(",", "");

        let num = Number.parseFloat(value_)
        if (num < MinIntegerCount && num != 0) {
            let val = num
            let sign = 1;
            if (val < 0) {
                sign = -1;
                val = -val;
            }
            if (sign < 0) {
                if (val < MinIntegerCount) {
                    return ConvertToExponential_(value, digit);
                } else {
                    return commaSeparateNumber(value, digit);
                }
            } else {
                return ConvertToExponential_(value, digit);

            }
        } else {
            return num == 0 ? (digit != undefined && digit != null) ? "0." + (("0").padStart(digit, "0")) : "0" : commaSeparateNumber(value, digit);
        }
    } else {
        return value;
    }
}

const ConvertToExponential_ = (value, digit = 3) => {
    let result = ""
    let value_ = (value + "").replaceAll(",", "");
    let num = Number.parseFloat(value_)
    if (!isNaN(num)) {
        result = num.toExponential(digit).replace(/e/g, 'E');
    }
    return result
}

//#endregion